import { render, staticRenderFns } from "./works.vue?vue&type=template&id=1633191e&"
import script from "./works.vue?vue&type=script&lang=js&"
export * from "./works.vue?vue&type=script&lang=js&"
import style0 from "./works.vue?vue&type=style&index=0&id=1633191e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports